import Login               from "../layouts/Login/Login";
import Project             from "../layouts/FindProject/Project";
import UploadPhoto         from "../layouts/Users/UploadPhoto";

// per fare una nuova rott abisogna replicare per bene tutto il giro 
// perchè c'ha riferimenti sparsi nei moduli che poi usa
import UploadPhotoMultiplo         from "../layouts/Users/UploadPhotoMultiplo";

import ConfirmUploadPhoto  from "../layouts/Users/ConfirmUploadPhoto";
import Home                from "../layouts/Home/Home";
import UploadCalendar from "../layouts/Calendar/UploadCalendar";
import ConfirmUploadCalendar from "../layouts/Calendar/ConfirmUploadCalendar";

const indexRoutes = [
    { path: "/login", name: "Login", component: Login },
    { path: "/project", name: "Project", component: Project },
    
    { path: "/upload-photo", name: "UploadPhotoMultiplo", component: UploadPhotoMultiplo },    
    // { path: "/upload-photo", name: "UploadPhoto", component: UploadPhoto },
    // { path: "/upload-photo-multi", name: "UploadPhotoMultiplo", component: UploadPhotoMultiplo },
    
    { path: "/upload-calendar",name:"UploadCalendar",component: UploadCalendar },
    { path: "/confirm-upload-photo", name: "UploadPhoto", component: ConfirmUploadPhoto },
    { path: "/confirm-upload-calendar", name: "ConfirmUploadCalendar", component: ConfirmUploadCalendar },
    // { path: "/", name: "Dashboard", component: Dashboard },
    { path: "/", name: "Home", component: Home },
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx